import "src/css/widgets/widgets.css";

import { connect } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState, useEffect, useMemo } from 'react';
import MonitorWSService from 'src/services/monitorwsservice';
import { useTranslation } from 'react-i18next';
import WidgetSettings from "./widgetSettings"
import { removeWidget } from "src/redux/supervisorSlice";
import { selectionTypes } from "src/components/utils/consts";
import {
    DataGrid, Column, ColumnChooser, StateStoring, Paging, Sorting, SearchPanel, Scrolling
} from 'devextreme-react/data-grid';
import { seconds2HMS } from "src/components/utils/utils";
import CallStatus from "./queuedcallsdetail/callstatus";
import TransferButton from "./queuedcallsdetail/transferbutton";
import DataSource from 'devextreme/data/data_source';
import ArrayStore from "devextreme/data/array_store";
import WidgetTools from "./widgetTools";


function QueuedCallsDetail(props) {

    const dataSource = useMemo(() => {
        return new DataSource({
            store: new ArrayStore({
                key: 'id',
                data: []
            }),
            reshapeOnPush: true
        })
    }, []);

    const { t } = useTranslation();
    const [queuedCalls, setQueuedCalls] = useState([]);
    const [showSettings, setShowSettings] = useState(false);
    const [selectedGroups, setSelectedGroups] = useState([]);

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/queuedcalls", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("queuedcalls");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

        if (props.connected) {

            let selectedGroups = JSON.parse(localStorage.getItem(`QueuedCalls_groups_${props.identifier}_user${props.id}`) || "[]");
            setSelectedGroups(selectedGroups);

            MonitorWSService.stompClient.send("/app/subscribe/queuedcalls", {}, JSON.stringify({
                token: props.token,
                groupsIds: selectedGroups
            }));

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/queuedcalls/`, updateState, { id: "queuedcalls" });

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected, props.notify, props.notifyAudio, props.timeInQueue]);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const selectGroups = (groups) => {
        setShowSettings(!showSettings);
        setSelectedGroups(groups);
        localStorage.setItem(`QueuedCalls_groups_${props.identifier}_user${props.id}`, JSON.stringify(groups));
        MonitorWSService.stompClient.send("/app/subscribe/queuedcalls", {}, JSON.stringify({
            token: props.token,
            groupsIds: groups
        }));

    };


    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    //! TODO: Un culpable del  MEMORY LEAK
    const rowPrepared = (e) => {
        if (e.rowType === "data" && props?.functions?.transferCall) {
            e.rowElement.setAttribute("draggable", true);
            e.rowElement.addEventListener('dragstart', x => {
                x.dataTransfer.setData('text/plain', JSON.stringify(e.data));
            });
        }
    }


    const updateState = (calls) => {
        if (!document.hidden) {
            var data = JSON.parse(calls.body);

            data.forEach(v => {
                v.timeInQueueAlarm = false;
                var queueDate = new Date();
                queueDate.setSeconds(queueDate.getSeconds() - v.timeWaiting);
                queueDate.setMilliseconds(1);
                var diff = v.timeWaiting;
                v.queueDate = queueDate;

                v.waitingTime = seconds2HMS(diff);
                if (props.notify) {
                    if (props.timeInQueue > 0 && diff > props.timeInQueue) {
                        v.status += "_ALARM";
                    }
                }
            });

            let callIds = dataSource.items().map(x => x.id);

            callIds.forEach(x => {
                if (data.map(c => c.id).indexOf(x) === -1) {
                    dataSource.store().push([{ type: 'remove', key: x }]);
                }

            });

            data.forEach(v => {
                if (callIds.indexOf(v.id) > -1) {
                    dataSource.store().push([{ type: 'update', key: v.id, data: v }]);
                } else {
                    dataSource.store().push([{ type: 'insert', data: v }]);
                }
            });

            //! TRAMPA debido a a un conflicto entre el render de la tabla y el de setqueuecalls
            if (data.length !== queuedCalls) {
                setTimeout(() => {
                    setQueuedCalls(data.length);
                }, 1000);
            }
        }
    }

    return (
        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"}>
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("phone-plus")} /> {t("queuedcallsdetail")} <span className="badge badge-light-primary fs-base">{queuedCalls}</span></span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ padding: "0px", height: "360px" }} >

                <DataGrid
                    id="queuedcallstable"
                    dataSource={dataSource}
                    showBorders={false}
                    columnAutoWidth={true}
                    width={"100%"}
                    height={"100%"}
                    allowColumnResizing={true}
                    repaintChangesOnly={true}
                    onRowPrepared={rowPrepared}
                    loadPanel={{ enabled: false }}
                    rtlEnabled={props.rtl}
                >
                    <Sorting mode={"single"} />
                    <StateStoring
                        enabled={true}
                        type="localStorage"
                        storageKey={`queuedCallsTableStorage_${props.identifier}_user${props.id}`}
                    />
                    <SearchPanel
                        visible={true}
                        width={240}
                        placeholder={t("search")}
                    />
                    <Paging enabled={false} />
                    <Scrolling
                        rowRenderingMode={"virtual"}
                        columnRenderingMode={"virtual"}
                    ></Scrolling>
                    <Column dataField="id" visible={false} showInColumnChooser={false} />
                    <Column cssClass={"align-middle"} dataField="transfer" caption={""} showInColumnChooser={false} width={60} cellRender={e => <TransferButton call={e.data} type={"call"} />} visible={props?.functions?.transferCall} />
                    <Column cssClass={"align-middle text-center"} dataField="status" caption={t("status")} showInColumnChooser={true} width={50} cellRender={e => <CallStatus call={e.data} />} />
                    <Column cssClass={"align-middle"} dataField="queueDate" caption={t("time")} dataType={"datetime"} format={"HH:mm:ss"} visible={true} width={70} />
                    <Column cssClass={"align-middle"} dataField="caller" caption={t("caller")} visible={true} width={100} />
                    <Column cssClass={"align-middle"} dataField="callerName" caption={t("callername")} visible={false} width={160} />
                    <Column cssClass={"align-middle"} dataField="called" caption={t("called")} visible={false} width={160} />
                    <Column cssClass={"align-middle"} dataField="calledName" caption={t("calledname")} visible={false} width={160} />
                    <Column cssClass={"align-middle"} dataField="groupName" caption={t("group")} visible={true} width={80} />
                    <Column cssClass={"align-middle"} dataField="waitingTime" caption={t("wait")} visible={true} width={100} />
                    <Column cssClass={"align-middle"} dataField="portExt" visible={false} showInColumnChooser={false} />
                    <Column cssClass={"align-middle"} dataField="agentName" visible={false} showInColumnChooser={false} />
                    <ColumnChooser enabled={true} mode={"select"} allowSearch={true} />
                </DataGrid>
            </div>
            <WidgetSettings key={`settings_${props.identifier}`} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroups={selectGroups} groups={selectedGroups} selectionType={selectionTypes.GROUPMULTIPLE}></WidgetSettings>

        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl,
        notify: state.parameters.notify,
        notifyAudio: state.parameters.notifyAudio,
        timeInQueue: state.parameters.timeInQueue,
        functions: state.supervisor.functions
    };
};

export default connect(mapStateToProps, { removeWidget })(QueuedCallsDetail);